import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { ManageTerminalsRootParamList } from "../../../../types";
import { useLoadMoreList } from "../../../../utilities/load-more-list";
import {
  Receipt,
  Terminal,
} from "@towersystems/roam-common/lib/generated-types";
import { QUERY_TERMINALS } from "../../common";
import { useFocusEffect } from "@react-navigation/native";
import React from "react";
import {
  Button,
  Divider,
  FlatActionList,
  FlatListSearchable,
  Page,
  View,
} from "@towersystems/roam-common-native";
import { FlatListSearchableSkeleton } from "../../../../components/FlatListSearchableSkeleton";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";

export type ManageTerminalsScreenProps = NativeStackScreenProps<
  ManageTerminalsRootParamList,
  "ManageTerminalsScreen"
>;

export const ManageTerminalsScreen = ({
  navigation,
}: ManageTerminalsScreenProps) => {
  const transitionEnded = useHasTransitionEnded(navigation);

  const loadMoreList = useLoadMoreList<Terminal>({
    initialLoad: false,
    query: QUERY_TERMINALS,
    resultKey: "terminals",
    sort: { updatedAt: "DESC" },

    variableFormatter: (variables) => {
      return {
        options: {
          ...variables,
          limit: 9999,
        },
      };
    },
  });

  useFocusEffect(
    // refresh the list when the screen is focused
    React.useCallback(() => {
      loadMoreList.loadMore(undefined, true);
    }, [])
  );

  const renderItem = React.useCallback(({ item }: { item: Terminal }) => {
    return (
      <FlatActionList.RenderItem
        item={{
          key: item.id,
          title: item.name,
          subTitle: item.terminalOpenTime,
          onPress: () => {
            navigation.navigate("EditTerminalScreen", {
              screen: "TerminalFormScreen",
              terminalId: item.id,
            });
          },
        }}
      ></FlatActionList.RenderItem>
    );
  }, []);

  if (
    (loadMoreList.loading && loadMoreList.items.length == 0) ||
    !transitionEnded
  ) {
    return <FlatListSearchableSkeleton searchbar={false} />;
  }

  return (
    <Page
      title="Retail Terminals"
      secondaryTitle="Manage your store terminal configurations and visability"
      scrollable={true}
    >
      <FlatListSearchable
        renderSearchBarHeader={() => <View />}
        ItemSeparatorComponent={Divider}
        renderItem={renderItem}
        data={loadMoreList.items ?? []}
      />
    </Page>
  );
};
